import type { PublicWorkspace } from '../types'
import { withStandardLibraryAssets } from './standard-content'

// DEMO DATA. Fictional Customer Success workspace for local design review
// only. It mirrors a renewing customer with little content yet: no
// summary or metrics, one Prentus member without a booking link, no
// customer team, calls or order forms, a draft renewal (hidden from the
// customer), and the license calculator visible. It has two published
// projects with three documents (example.com links), like a renewal plus a
// design project. Otherwise it carries only the standard library assets.
export const SUCCESS_RENEWAL_DEMO_PUBLIC_ID = 'success-renewal-preview'

export const SUCCESS_RENEWAL_DEMO_PUBLIC_WORKSPACE: PublicWorkspace = {
  id: '3b8e1f20-7c4d-4a9e-8f61-renewaldemo01',
  publicId: SUCCESS_RENEWAL_DEMO_PUBLIC_ID,
  accountName: 'Harbor Workforce Network (Demo)',
  accountLogoUrl: null,
  customerSegment: 'bootcamp_workforce',
  phase: 'customer_success',
  pricingModel: 'license',
  pricingModes: 'auto',
  firstCallRecorded: true,
  overview: '',
  recap: 'Harbor has used Prentus with its fellows for the past year.\nThe current term ends in December, so we are planning the renewal now.\nUse the ROI & Pricing tab to size next year\'s licenses and add-ons.',
  currentNextStep: 'Choose the license count and add-ons for the next term.',
  precallOnepager: null,
  successContent: null,
  projects: [
    {
      id: 'renewal-demo-project-renewal',
      name: '2027 Renewal (Demo)',
      description: 'Agree on the license count, add-ons and terms for the next contract year.',
      status: 'in_progress',
      tasks: [
        { id: 'renewal-demo-task-1', title: 'Share platform and outcomes briefs', ownerName: 'Rod Danan', dueDate: '2026-10-22', status: 'complete' },
        { id: 'renewal-demo-task-2', title: 'Review the briefs with the leadership team', ownerName: 'Harbor team', dueDate: '2026-11-05', status: 'open' },
        { id: 'renewal-demo-task-3', title: 'Choose licenses and add-ons in ROI & Pricing', ownerName: 'Harbor team', dueDate: '2026-11-12', status: 'open' },
        { id: 'renewal-demo-task-4', title: 'Send the Order Form for signature', ownerName: 'Rod Danan', dueDate: null, status: 'open' },
      ],
    },
    {
      id: 'renewal-demo-project-admin',
      name: 'Employer Relations Admin Redesign (Demo)',
      description: 'A simpler admin view for the employer relations team, tested with a clickable prototype.',
      status: 'in_progress',
      tasks: [
        { id: 'renewal-demo-task-5', title: 'Interview the employer relations team', ownerName: 'Rod Danan', dueDate: '2026-09-30', status: 'complete' },
        { id: 'renewal-demo-task-6', title: 'Map the current employer workflow', ownerName: 'Rod Danan', dueDate: '2026-10-07', status: 'complete' },
        { id: 'renewal-demo-task-7', title: 'Build the clickable prototype', ownerName: 'Rod Danan', dueDate: '2026-10-21', status: 'complete' },
        { id: 'renewal-demo-task-8', title: 'Review the prototype with Harbor', ownerName: 'Harbor team', dueDate: '2026-10-28', status: 'complete' },
        { id: 'renewal-demo-task-9', title: 'Agree on the release plan', ownerName: 'Rod Danan', dueDate: '2026-11-10', status: 'in_progress' },
      ],
    },
  ],
  renewal: null,
  orderForms: [],
  prequalificationOnly: false,
  businessCase: [],
  members: [
    { id: 'renewal-demo-rod', side: 'prentus', name: 'Rod Danan', title: null, email: null, bookingUrl: null, avatarUrl: null },
  ],
  tasks: [],
  assets: withStandardLibraryAssets([
    { id: 'renewal-demo-doc-platform', sectionKey: 'projects', type: 'external_link', title: 'Platform Brief (Demo)', description: 'How Harbor fellows and staff used Prentus this year, and what the next term adds.', url: 'https://example.com/demo/platform-brief', metadata: { projectId: 'renewal-demo-project-renewal' } },
    { id: 'renewal-demo-doc-outcomes', sectionKey: 'projects', type: 'external_link', title: 'Outcomes Brief (Demo)', description: 'Placement and engagement results for the current term.', url: 'https://example.com/demo/outcomes-brief', metadata: { projectId: 'renewal-demo-project-renewal' } },
    { id: 'renewal-demo-doc-prototype', sectionKey: 'projects', type: 'external_link', title: 'Clickable Admin Prototype (Demo)', description: 'Try the redesigned employer relations admin before it ships.', url: 'https://example.com/demo/admin-prototype', metadata: { projectId: 'renewal-demo-project-admin' } },
  ]),
  calculatorInputs: {},
  quotes: [],
  pricingLocked: false,
  viewerEmail: 'preview@harbor.example',
  updatedAt: '2026-10-29T12:00:00.000Z',
}
